// extracted by mini-css-extract-plugin
module.exports = {"root":"IconAdd_root__1Pqp3"};